module.exports = __webpack_public_path__ + "static/media/my_photo.14c70b50.png";